const $ = window.jQuery;

class FAQ {
  constructor(section) {
    const faq = $(section);

    const selectors = {
      button: '.js-faq-item-button',
      content: '.js-faq-item-content',
      item: '.js-faq-item',
    };

    const classes = {
      active: 'is-active',
    };

    const buttons = faq.find(selectors.button);

    $.each(buttons, (i, b) => {
      $(b).on('click', () => {
        const button = $(b);
        const item = button.closest(selectors.item);
        const activeItem = $(`${selectors.item}.${classes.active}`);
        const itemContent = item.find(selectors.content);

        if (activeItem.length && activeItem.attr('id') !== item.attr('id')) {
          const activeItemContent = activeItem.find(selectors.content);
          const activeItemButton = activeItem.find(selectors.button);
          activeItemContent.slideUp(300);
          activeItem.removeClass(classes.active);
          activeItemButton.attr('aria-expanded', false);
        }

        if (item.hasClass(classes.active)) {
          itemContent.slideUp(300);
          item.removeClass(classes.active);
          button.attr('aria-expanded', false);
        } else {
          itemContent.slideDown(300);
          item.addClass(classes.active);
          button.attr('aria-expanded', true);
        }
      });
    });
  }
}

const faqInit = () => {
  const sections = document.querySelectorAll('.js-faq-items');

  if (sections.length) {
    sections.forEach(section => new FAQ(section));
  }
};

export default faqInit();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/faq.js